import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { stack as Menu } from "react-burger-menu";
import "../assets/styles/Header.css"; // Ensure the CSS file exists

const Header = ({data, logo}) => {
  const [isHeaderVisible, setIsHeaderVisible] = useState(true);
  const [hasBackground, setHasBackground] = useState(false);
  const [prevScrollPos, setPrevScrollPos] = useState(0);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation(); // Get current page path

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollPos = window.pageYOffset;
      const isScrollingDown = currentScrollPos > prevScrollPos;

      // Show/hide header logic
      setIsHeaderVisible(!isScrollingDown);

      // Header background logic
      setHasBackground(currentScrollPos > 100);

      setPrevScrollPos(currentScrollPos);
    };

    const throttledScroll = throttle(handleScroll, 100);
    window.addEventListener("scroll", throttledScroll);

    return () => {
      window.removeEventListener("scroll", throttledScroll);
    };
  }, [prevScrollPos]);

  // Function to check if the link is active
  const isActive = (path) => (location.pathname === path ? "active" : "");

  return (
    <header
      className={`header font-mono uppercase ${isHeaderVisible ? "visible" : "hidden1"} ${
        hasBackground ? "with-bg" : ""
      }`}
    >
      <nav className="nav-container">
        <div className="logo">
          <Link to="/">
            <img src={logo} alt="Logo" />
          </Link>
        </div>
        <ul className="nav-links desktop-only">
          {data.map((items, index) => (
            <li key={index}>
              <Link to={items.link} className={isActive(items.link)}>
                {items.label}
              </Link>
            </li>
          ))}
        </ul>

        {/* Mobile Responsive menu */}
        <div className="mobile-only">
          <Menu
            isOpen={isMenuOpen}
            onStateChange={(state) => setIsMenuOpen(state.isOpen)}
            right
          >
            {data.map((item, index) => (
              <Link
                key={index}
                to={item.link}
                className={isActive(item.link)}
                onClick={() => setIsMenuOpen(false)}
              >
                {item.label}
              </Link>
            ))}
          </Menu>
        </div>
      </nav>
    </header>
  );
};

// Throttle function for scroll optimization
function throttle(fn, wait) {
  let time = Date.now();
  return function () {
    if (time + wait - Date.now() < 0) {
      fn();
      time = Date.now();
    }
  };
}

export default Header;
